import React from 'react';
import styled from 'styled-components';

import Overview from './components/Overview';
import Chart from './components/Chart';
import Stats from './components/Stats';
import Bars from './components/Bars';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Data = styled.div`
  display: grid;
  gap: 70px;

  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;

    gap: 20px;
  }
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;

  @media (max-width: 1024px) {
    gap: 20px;
  }
`;

// eslint-disable-next-line no-unused-vars
export default function Analytics({ loading, error, data }) {
  return (
    <>
      <Wrapper>
        {!!data?.pageviews && <Overview data={data} $showOn="mobile" />}
        {!!data?.timeline && <Chart data={data.timeline} />}
        <Data>
          {!!data?.referrer && <Stats data={data.referrer} /> }
          {!!data?.page && <Stats data={data.page} /> }
          <Group>
            {!!data?.device && <Bars data={data.device} icons="devices" /> }
            {!!data?.browser
              && <Bars data={data.browser} icons="browsers" max={5} /> }
          </Group>
          {!!data?.country && <Bars data={data.country} icons="flags" /> }
        </Data>
      </Wrapper>

      {/* <pre>
        <code>
          {JSON.stringify(
            { loading, error, data },
            null,
            '  ',
          )}
        </code>
      </pre> */}
    </>
  );
}
